import React from 'react';
import AppRoutes from '../routes';
import Footer from '../components/demo/footer';
import Header from '../components/demo/header';
import HomePage from '../pages/demo/home_page';
import AboutPage from '../pages/demo/about_page';
import ContactPage from '../pages/demo/contact_page';

export default function DemoTemplate(props) {
    return (
        <React.Fragment>
            <Header />
            <AppRoutes
                homePage={HomePage}
                contactPage={ContactPage}
                aboutPage={AboutPage}
            />
            <Footer />
        </React.Fragment>
    )
}
